<template>
  <modal
    :show.sync="showRequestRecipients"
    modalContentClasses=""
    modalClasses="modal-alert"
    type="mini"
    @close="closeRequestRecipientsModal"
    no-close-on-backdrop
  >
    <div
      class="col-12 pt-4 pb-2"
      :class="{ 'is-invalid': $v.recipient.$error }"
    >
      <div class="text-center">
        <img
          src="~rhomtrip_assets/src/img/icons/alerts/question.png"
          alt="question"
          class="icon-modal"
        />
        <h2 class="modal-title mb-1">
          Update Reservation
        </h2>
      </div>

      <p>Are you sure you want to <strong>update</strong> this reservation?</p>
      <p>
        Select an option to <strong>send a notification</strong> and enter a
        <strong>Reason</strong> for the update
      </p>

      <b-form-radio-group
        id="radio-recipient"
        v-model="recipient"
        aria-describedby="ariaDescribedby"
        name="radio-recipient"
        stacked
        size="md"
      >
        <b-form-radio
          value="CUSTOMER"
          tabindex="15"
          v-if="recipients.includes('CUSTOMER')"
          >Customer</b-form-radio
        >
        <b-form-radio
          value="AGENT"
          tabindex="15"
          v-if="recipients.includes('AGENT')"
          >Agent</b-form-radio
        >
        <b-form-radio value="SUPPLIER" v-if="recipients.includes('SUPPLIER')"
          >Supplier</b-form-radio
        >
        <b-form-radio value="PASSENGER" v-if="recipients.includes('PASSENGER')"
          >Passenger</b-form-radio
        >
        <b-form-radio value="ALL" v-if="recipients.includes('ALL')"
          >All</b-form-radio
        >
        <b-form-radio
          value="NOT_NOTIFY"
          v-if="recipients.includes('NOT_NOTIFY')"
          >Not Notify</b-form-radio
        >
      </b-form-radio-group>

      <small v-if="$v.recipient.$error" class="text-center invalid-feedback"
        >Select an Option</small
      >

      <div class="col-12 mt-3 p-0">
        <label class="title-label"
          >Reason of update<el-popover
            placement="bottom"
            trigger="hover"
            width="300"
            class="curp"
          >
            <span>
              This information is only used as history notes within RhomTrip
            </span>
            <div class="badge badge-primary" slot="reference">?</div>
          </el-popover></label
        >
        <el-input
          v-model="reason"
          placeholder="Other Reason"
          id="OtherReason"
          name="OtherReason"
          maxlength="160"
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 5 }"
          show-word-limit
        >
        </el-input>
        <small class="invalid-feedback" v-if="$v.reason.$error"
          >Enter a reason</small
        >
      </div>
    </div>
    <div
      class="border-top pt-3 text-center col-12 d-flex justify-content-around"
    >
      <base-button
        type="outline-neutral"
        class="min-button"
        @click="closeRequestRecipientsModal()"
        >No</base-button
      >

      <base-button
        type="primary"
        class="min-button ml-auto"
        @click.stop="populateRecipients()"
        >Yes</base-button
      >
    </div>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

export default {
  name: "UpdateReservation",
  props: {
    recipients: {
      type: Array,
      default: () => [
        "NOT_NOTIFY",
        "ALL",
        "PASSENGER",
        "SUPPLIER",
        "CUSTOMER",
        "AGENT"
      ],
      description: "recipients"
    },
    show: {
      type: Boolean,
      default: false,
      description: "(closeable)"
    }
  },
  data() {
    return {
      recipient: "NOT_NOTIFY",
      reason: "",
      showRequestRecipients: true
    };
  },
  async created() {
    this.showRequestRecipients = this.show;
  },
  watch: {
    show: {
      handler: function(current, old) {
        this.showRequestRecipients = current;
      },
      deep: true
    }
  },
  methods: {
    async populateRecipients() {
      if (!this.$v.$invalid) {
        this.$emit("onPopulateRecipients", {
          recipients: this.getRecipients(this.recipient),
          reason: this.reason
        });
        this.resetData();
      } else {
        this.$v.$touch();
      }
    },
    closeRequestRecipientsModal() {
      this.showRequestRecipients = false;
      this.$emit("onCloseRequestRecipients", false);
      this.resetData();
    },
    resetData() {
      this.recipient = "NOT_NOTIFY";
      this.reason = "";
      this.$v.$reset();
    },
    getRecipients(recipient) {
      if (recipient === "NOT_NOTIFY") {
        return [];
      } else if (recipient === "ALL") {
        return ["CUSTOMER", "AGENT", "SUPPLIER", "PASSENGER", "ADMIN"];
      } else {
        return [recipient];
      }
    }
  },
  computed: {
    ...mapGetters(["sesion"])
  },
  validations: {
    recipient: {
      required
    },
    reason: {
      minLength: minLength(2),
      maxLength: maxLength(160)
    }
  }
};
</script>
